var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 161,
    viewBox: "0 0 167 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 21C100 59.4478 64.4062 91 33 91C64.4062 91 100 122.552 100 161C100 122.552 135.594 91 167 91C135.594 91 100 59.4478 100 21Z",
    fill: "#ff7300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0C32.5 18.6746 15.2344 34 0 34C15.2344 34 32.5 49.3254 32.5 68C32.5 49.3254 49.7656 34 65 34C49.7656 34 32.5 18.6746 32.5 0Z",
    fill: "#ff7300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 113C32.5 124.809 21.6094 134.5 12 134.5C21.6094 134.5 32.5 144.191 32.5 156C32.5 144.191 43.3906 134.5 53 134.5C43.3906 134.5 32.5 124.809 32.5 113Z",
    fill: "#ff7300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/aiIcon.c6aac6c7fe0558e4a0cb66ea0eeb8158.svg";
export { ForwardRef as ReactComponent };